import isEqual from 'lodash.isequal'

export class TrackEventQueue {
  /**
   * @type {import('./analytics-tracker').AnalyticsTracker}
   * @private
   */
  _tracker

  /**
   * @type {import('./track-strategy-registry').TrackStrategyRegistry}
   * @private
   */
  _registry

  /**
   * @type {Array<{ type: string, action: string, [key: string]: string | number | boolean }>}
   * @private
   */
  _queue = []

  /**
   * @param {import('./analytics-tracker').AnalyticsTracker} tracker - The analytics tracker instance.
   * @param {import('./track-strategy-registry').TrackStrategyRegistry} registry - The track strategy registry instance.
   */
  constructor(tracker, registry) {
    this._tracker = tracker
    this._registry = registry
  }

  /**
   * Checks if an event already exists in the queue.
   * @param {object} event - The event object to check.
   * @param {string} event.type - The action type of the event.
   * @param {Record<string, string | number | boolean>} [event.rest] - Additional event properties.
   * @returns {boolean} True if the event exists, false otherwise.
   * @private
   */
  _isAlreadyQueued(event) {
    return this._queue.some((queuedEvent) => {
      return isEqual(event, queuedEvent)
    })
  }

  /**
   * @param {object} event - The event object to queue.
   * @param {string} event.action - The action type of the event.
   * @param {Record<string, string | number | boolean>} [event.rest] - Additional event properties.
   * @returns {void}
   */
  queue(event) {
    if (!this._isAlreadyQueued(event)) {
      this._queue.push(event)
    }
  }

  /**
   * @returns {void} Processes the queued events if the tracker instance is available.
   */
  unqueue() {
    if (this._tracker.isInstanceAvailable && this._queue.length > 0) {
      while (this._queue.length > 0) {
        const event = this._queue.shift()
        this._registry.retrieve(event.action).track(event)
      }
    }
  }
}
